module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/purebarre-b1c0985e71f56fde193fc64b81cf134a.png";